var map = {
	"./bg.mp4": 1155,
	"./english-for-kids.mp4": 9048,
	"./general-english.mp4": 8551,
	"./ielts-turbo.mp4": 2245,
	"./ielts-up.mp4": 8453,
	"./ielts.mp4": 6,
	"./intro.mp4": 3116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9354;